/**
 *
 * DateBadge
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import PinDateIcon from '../../../../assets/v2/PinDateIcon';
import { COLORS } from '../../../../theme';
import Badge from '..';

const StyledBadge = styled(Badge)`
  &.MuiChip-root {
    color: ${COLORS.kinetikBlue};
    background: ${COLORS.kinetikBlueTransparent};
    border-color: ${COLORS.kinetikBlue};
  }

  && .MuiSvgIcon-root {
    path {
      fill: ${COLORS.kinetikBlue};
    }
  }
`;

function DateBadge(props) {
  return (
    <StyledBadge
      icon={<PinDateIcon />}
      size="iconLarge"
      variant="outlined"
      {...props}
    />
  );
}

export default memo(DateBadge);
